<template lang="pug">
    .about
        main(ref="main" v-if="dataLoaded")
            app-nav(:class="{black:isScrollingOneScreen}")
            section.aboutIntro.scrollme.animateme(data-when='span' data-from='0' data-to='0.7' data-easing="linear" data-opacity='0' )
                .container
                    .yellowP
                    .center
                        .benefits
                            .item технологии
                            .item команда
                            .item доверие
                        .title Мы <span>&ndash;</span> progression
                        .subtitle idea drives roi
                    .holding Progression group<br> Год основания - 2001
                    .companiesLinks
                        a(href="").link
                            img(src="../assets/img/about/link-basecamp.png")
                        a(href="").link
                            img(src="../assets/img/about/link-jira.png")
                        a(href="").link
                            img(src="../assets/img/about/link-zplayground.png")
                        a(href="").link
                            img(src="../assets/img/about/link-microsoft.png")
                        a(href="").link
                            img(src="../assets/img/about/link-ecovadis.png")


            section.weDo.doJoin.scrollme
                .bg.animateme(data-when='span' data-from='0.4' data-to='0.1' data-easing="linear" data-opacity='0')
                .container
                    .content
                        .left
                            .title.animateme(data-when='span' :data-from='!isMobile?0.4:0.2' :data-to='!isMobile?0.25:0.1' data-easing="linear" data-opacity='0' data-translateY="100")
                                div(v-html="aboutContent.doJoin_title.content")
                            .strip.animateme(data-when='span' :data-from='!isMobile?0.45:0.3' :data-to='!isMobile?0.3:0.2' data-easing="linear" data-opacity='0' data-translateX="-100")
                            .text.animateme(data-when='span' :data-from='!isMobile?0.5:0.4' :data-to='!isMobile?0.35:0.25' data-easing="linear" data-opacity='0' data-translateY="100")
                                div(v-html="aboutContent.doJoin_text.content")
                        .right.animateme(data-when='span' :data-from='!isMobile?0.5:0.5' :data-to='!isMobile?0.3:0.4' data-easing="linear" :data-translateY="!isMobile?300:150" data-scale="1.4")
                            div.animateme(data-when='span' :data-from='!isMobile?0.4:0.4' :data-to='!isMobile?0.1:0.3' data-easing="linear" data-opacity='0')

            section.weDo.doProjects.scrollme
                .decor.d1.animateme(data-when='span' data-from='0.3' data-to='0.2' data-easing="linear" data-opacity='0' data-scale="0.7" data-translateY="100" data-translateX="200")
                .decor.d2.animateme(data-when='span' data-from='0.35' data-to='0.25' data-easing="linear" data-opacity='0' data-scale="0.7" data-translateY="100" data-translateX="200")
                .decor.d3.animateme(data-when='span' data-from='0.4' data-to='0.3' data-easing="linear" data-opacity='0' data-scale="0.7" data-translateY="100" data-translateX="200")
                .decor.d4.animateme(data-when='span' data-from='0.45' data-to='0.35' data-easing="linear" data-opacity='0' data-scale="0.7" data-translateY="100" data-translateX="200")
                .container
                    .content
                        .left
                            .title.animateme(data-when='span' :data-from='!isMobile?0.4:0.2' :data-to='!isMobile?0.25:0.1' data-easing="linear" data-opacity='0' data-translateY="100")
                                div(v-html="aboutContent.doProjects_title.content")
                            .strip.animateme(data-when='span' :data-from='!isMobile?0.45:0.3' :data-to='!isMobile?0.3:0.2' data-opacity='0' data-translateX="-100")
                            .text.animateme(data-when='span' :data-from='!isMobile?0.5:0.4' :data-to='!isMobile?0.35:0.25' data-easing="linear" data-opacity='0' data-translateY="100")
                                div(v-html="aboutContent.doProjects_text.content")
                            .watchCase.animateme(v-if="!isMobile" data-when='span' data-from='0.5' data-to='0.45' data-easing="linear" data-opacity='0')
                                router-link.play(:to="{name:'case',params:{id:aboutContent.doProjects_link.content}}")
                                span смотреть кейс
                        .right.animateme(data-when='span' :data-from='!isMobile?0.5:0.5' :data-to='!isMobile?0.3:0.4' data-easing="linear" data-translateY="300" data-scale="1.2")
                            .absolute.animateme(data-when='span' :data-from='!isMobile?0.4:0.5' :data-to='!isMobile?0.1:0.4' data-easing="linear" data-opacity='0' :style="{backgroundImage:'url('+$rootPath+'/backend/img/aboutContent/'+aboutContent.doProjects_img.content+')'}")
                            .watchCase.animateme(v-if="isMobile" data-when='span' :data-from='!isMobile?0.5:0.6' :data-to='!isMobile?0.45:0.5' data-easing="linear" data-opacity='0')
                                router-link.play(:to="{name:'case',params:{id:aboutContent.doProjects_link.content}}")
                                span смотреть кейс


            section.weDo.doResult.scrollme
                .decor.d1.animateme(data-when='span' data-from='0.3' data-to='0.1' data-easing="linear" data-opacity='0' data-scale="1.5")
                .decor.d2.animateme(data-when='span' data-from='0.35' data-to='0.2' data-easing="linear" data-opacity='0' data-scale="1.5")
                .decor.d3.animateme(data-when='span' data-from='0.4' data-to='0.3' data-easing="linear" data-opacity='0' data-scale="1.5")
                .decor.d4.animateme(data-when='span' data-from='0.5' data-to='0.35' data-easing="linear" data-opacity='0' data-scale="1.5")
                .container
                    .content
                        .left
                            .title.animateme(data-when='span' :data-from='!isMobile?0.3:0.2' :data-to='!isMobile?0.1:0.1' data-easing="linear" data-opacity='0' data-translateY="100")
                                div(v-html="aboutContent.doResult_title.content")
                            .strip.animateme(data-when='span' :data-from='!isMobile?0.35:0.25' :data-to='!isMobile?0.2:0.15' data-easing="linear" data-opacity='0' data-translateX="-100")
                            .text.animateme(data-when='span' :data-from='!isMobile?0.45:0.3' :data-to='!isMobile?0.3:0.2' data-easing="linear" data-opacity='0' data-translateY="100")
                                div(v-html="aboutContent.doResult_text.content")
                            .watchCase.animateme(v-if="!isMobile" data-when='span' data-from='0.5' data-to='0.35' data-easing="linear" data-opacity='0')
                                router-link.play(:to="{name:'case',params:{id:aboutContent.doResult_link.content}}")
                                span смотреть кейс
                        .right.animateme(data-when='span' :data-from='!isMobile?0.5:0.45' :data-to='!isMobile?0.3:0.35' data-easing="linear" data-translateY="300" data-scale="1.2")
                            .absolute.animateme(data-when='span' :data-from='!isMobile?0.4:0.4' :data-to='!isMobile?0.1:0.3' data-easing="linear" data-opacity='0' :style="{backgroundImage:'url('+$rootPath+'/backend/img/aboutContent/'+aboutContent.doResult_img.content+')'}")
                            .watchCase.animateme(v-if="isMobile" data-when='span' :data-from='!isMobile?0.5:0.5' :data-to='!isMobile?0.35:0.4' data-easing="linear" data-opacity='0')
                                router-link.play(:to="{name:'case',params:{id:aboutContent.doResult_link.content}}")
                                span смотреть кейс
                            .statistic.animateme(data-when='span' :data-from='!isMobile?0.5:0.7' :data-to='!isMobile?0.4:0.5' data-easing="linear" data-opacity='0')
                                .stat
                                    .big(v-html="aboutContent.doResult_stats.content.stat1.big")
                                    small(v-html="aboutContent.doResult_stats.content.stat1.small")
                                .stat
                                    small(v-html="aboutContent.doResult_stats.content.stat2.small")
                                    .big(v-html="aboutContent.doResult_stats.content.stat2.big")
                                .stat
                                    small(v-html="aboutContent.doResult_stats.content.stat3.small")
                                    .big(v-html="aboutContent.doResult_stats.content.stat3.big")
                                .stat
                                    .big(v-html="aboutContent.doResult_stats.content.stat4.big")
                                    small(v-html="aboutContent.doResult_stats.content.stat4.small")

            section.weDo.doSplitExp.scrollme
                .container
                    .content
                        .left
                            .title.animateme(data-when='span' :data-from='!isMobile?0.6:0.2' :data-to='!isMobile?0.5:0.1' data-easing="linear" data-opacity='0' data-translateY="100")
                                div(v-html="aboutContent.doSplitExp_title.content")
                            .strip.animateme(data-when='span' :data-from='!isMobile?0.65:0.3' :data-to='!isMobile?0.55:0.2' data-easing="linear" data-opacity='0' data-translateX="-100")
                            .text.animateme(data-when='span' :data-from='!isMobile?0.7:0.35' :data-to='!isMobile?0.6:0.25' data-easing="linear" data-opacity='0' data-translateY="100")
                                div(v-html="aboutContent.doSplitExp_text.content")
                        .right
                            .articlesLinks.animateme(data-when='span' data-from='0.6' data-to='0.4' data-easing="linear" data-opacity="0" data-scale="1.3")
                                .link(v-for="(link, ind) in aboutContent.doSplitExp_linkList.content" :key="ind")
                                    span(v-html="link.span")
                                    a(:href="link.a" target="_blank" v-html="link.name")

            app-footer
</template>

<script>
    export default {
        name: "About",
        data:()=>({
            isMobile: document.documentElement.offsetWidth < 769,
            isScrollingOneScreen:window.pageYOffset > window.outerHeight,
            aboutContent:{},
            dataLoaded:false,
        }),
        async mounted() {
            await this.fetchContent();
            setTimeout(() => {
                window.scrollme();
                $(".weDo.doSplitExp .articlesLinks").mCustomScrollbar();
                this.$refs['main'].classList.add('loaded');
            }, 400);

            window.addEventListener('scroll',this.updateOneScreen);
        },
        beforeDestroy(){
            window.removeEventListener('scroll',this.updateOneScreen);
        },
        methods:{
            updateOneScreen(){
                this.isScrollingOneScreen=window.pageYOffset > window.outerHeight/2;
            },
            async fetchContent() {
                let data = new FormData();
                data.append('action','fetchAboutContent');
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                if (!responseData.error) {
                    let aboutContent = {};
                    responseData.content.forEach(el => {
                        let {name, ...params} = el;
                        aboutContent[name] = {name, ...params};
                    });
                    this.aboutContent = aboutContent;
                    this.aboutContent.doSplitExp_linkList.content = JSON.parse(this.aboutContent.doSplitExp_linkList.content);
                    this.aboutContent.doResult_stats.content = JSON.parse(this.aboutContent.doResult_stats.content);
                    this.dataLoaded = true;
                } else {
                    console.log(responseData);
                }
            },
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_mixins.scss";

    .about {
        main:not(.loaded) {
            .yellowP {
                transform: scale(0.8);
                opacity: 0;
            }
            .center {
                .benefits {
                    .item {
                        transform: translateY(-10%);
                        opacity: 0;
                    }

                }
                .title {
                    transform: scale(0.9);
                    opacity: 0;

                }
                .subtitle {
                    transform: scale(0.9);
                    opacity: 0;
                }
            }
            .holding {
                transform: translateX(10%);
                opacity: 0;
            }
            .companiesLinks {
                opacity: 0;
            }
        }

        section.aboutIntro {
            height: 100vh;

            background: url(../assets/img/about/aboutIntro_bg.jpg) no-repeat center center / cover;
            color: #fff;
            transition: .2s;
            .container {
                position: relative;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .yellowP {
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    pointer-events: none;
                    transform-origin: center;
                    background: url(../assets/img/about/aboutIntro_bg-yellow.svg) no-repeat 50% 52%/auto 38.9rem;
                    transition: 2s 1s;
                }
            }
            .center {
                width: 100%;
                margin-top: -2rem;
                text-transform: uppercase;
                .benefits {
                    display: flex;
                    justify-content: space-around;
                    font: 800 to_rem(20px)/to_rem(120px) Geometria;
                    letter-spacing: to_rem(4.95px);
                    opacity: 0.6;
                    .item {
                        &:nth-of-type(1) {
                            transition: .2s linear .6s;
                        }

                        &:nth-of-type(2) {
                            transition: .2s linear .75s;
                        }

                        &:nth-of-type(3) {
                            transition: .2s linear .9s;
                        }
                    }
                }
                .title {
                    margin-bottom: 2.5rem;
                    margin-left: 2.1%;
                    text-align: center;
                    font: 900 to_rem(40px)/to_rem(47px) Geometria;
                    letter-spacing: to_rem(26.03px);
                    transition: .9s;
                }
                .subtitle {
                    text-align: center;
                    font: 700 to_rem(20px)/to_rem(24px) Geometria;
                    transition: .5s .5s;
                }
            }
            .holding {
                position: absolute;
                text-transform: uppercase;
                bottom: 13%;
                right: 6.2%;
                text-align: right;
                font: 800 to_rem(14px)/to_rem(24px) Geometria;
                letter-spacing: to_rem(1px);
                transition: .4s .9s;
            }
            .companiesLinks {
                position: absolute;
                bottom: 2.7%;
                left: 0;
                right: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                transition: .7s 1.5s;
                a {
                    margin: 0 2.03%;
                }
            }
        }

        section.weDo {
            position: relative;
            height: 100vh;
            background: no-repeat center center / cover;
            color: #000;
            .bg {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
            }
            &.doJoin {
                .bg {
                    background-color: #fff2d2;
                }
                .content {
                    .left {
                        padding: 11% 0 10%;
                    }
                    .right {
                        flex-basis: 66%;
                        transition: .3s linear;
                        div {
                            transition: .3s linear;
                            width: 100%;
                            height: 100%;
                            transform: translate(2.5%, -0.5%);
                            background: url(../assets/img/about/weDo-join.png) no-repeat center right / 88% auto;
                        }
                    }
                }
            }

            &.doProjects {
                overflow: hidden;
                background-color: #f0e9ff;
                .decor {
                    position: absolute;
                    background: no-repeat center center / contain;
                    z-index: 0;
                    top: -28%;
                    left: 16.5%;
                    right: -5.5%;
                    bottom: -21%;
                    transition: .4s;
                    &.d1 {background-image: url(../assets/img/about/decor/doProjects_bg-1.svg);}
                    &.d2 {background-image: url(../assets/img/about/decor/doProjects_bg-2.svg);}
                    &.d3 {background-image: url(../assets/img/about/decor/doProjects_bg-3.svg);}
                    &.d4 {background-image: url(../assets/img/about/decor/doProjects_bg-4.svg);}
                }
            }
            &.doResult {
                background-color: #e9faff;
                overflow: hidden;
                .decor {
                    position: absolute;
                    background: no-repeat center center / 100% 100%;
                    transition: .4s;
                    &.d1 {
                        top: 0;
                        left: 29.3%;
                        right: 0;
                        bottom: 0;
                        background-image: url(../assets/img/about/decor/doResult_bg-1.svg);
                        transition-delay: .05s;
                    }
                    &.d2 {
                        top: 3%;
                        left: 39.1%;
                        right: 8.6%;
                        bottom: 0%;
                        background-image: url(../assets/img/about/decor/doResult_bg-2.svg);
                        transition-delay: .1s;
                    }
                    &.d3 {
                        top: 21%;
                        left: 48.8%;
                        right: 18.3%;
                        bottom: 17.8%;
                        background-image: url(../assets/img/about/decor/doResult_bg-3.svg);
                        transition-delay: .15s;
                    }
                    &.d4 {
                        top: 36%;
                        left: 58%;
                        right: 27.5%;
                        bottom: 35%;
                        background-image: url(../assets/img/about/decor/doResult_bg-4.svg);
                        transition-delay: .2s;
                    }
                }
                .content {
                    margin-top: 6.5%;
                    .left {
                        flex-basis: 28%;
                        padding: 0;
                        .title {
                            margin-bottom: 3.5rem;
                        }
                    }
                    .right {
                        flex-basis: 48.9%;
                        flex-direction: column;
                        .absolute {
                            width: 91.5%;
                            margin-right: 8.2%;
                            padding-top: 51.5%;
                            margin-top: 0.5%;
                            margin-bottom: 5.8rem;
                        }
                        .statistic {
                            display: flex;
                            flex-wrap: wrap;
                            .stat {
                                width: 45.5%;
                                margin-bottom: 2.3rem;
                                line-height: to_rem(23px);
                                .big {
                                    font-size: to_rem(22px);
                                }
                                small {
                                    font-size: to_rem(16px);
                                }
                            }
                        }
                    }
                }
            }
            &.doSplitExp {
                background-image: url(../assets/img/about/weDo-splitExp-bg.jpg);
                .content {
                    .left {
                        padding: 11% 0 0;
                        .title {
                            margin-bottom: 3.2rem;
                        }
                    }
                    .right {
                        height: 40rem;
                        justify-content: flex-start;
                        flex-basis: 48.4%;
                        .articlesLinks {
                            width: 30.8rem;
                            max-width: 90%;
                            max-height: 100%;
                            overflow: auto;
                            .mCSB_scrollTools .mCSB_dragger {
                                height: to_rem(20px) !important;
                                min-height: initial;
                                background-color: #ffc819;
                                width: to_rem(20px);
                                border-radius: 50%;
                            }
                            .mCSB_scrollTools {
                                width: to_rem(20px);
                            }
                            .mCSB_scrollTools .mCSB_draggerRail {
                                width: 1px;
                                background: #bfccb1;
                            }
                            .mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
                                display: none;
                            }
                            .link {
                                max-width: 87%;
                                font-size: to_rem(16px);
                                line-height: to_rem(32px);
                                padding: 1rem 0 1.6rem;
                                &:not(:last-child) {
                                    border-bottom: 1px solid #d7e6c7;
                                }
                                &:hover {
                                    span, a {
                                        color: #000;
                                    }
                                }
                                a:hover {
                                    text-decoration: underline;
                                }
                                span, a {
                                    transition: .3s;
                                    color: #7c7c7c;
                                }
                                span {
                                    display: block;
                                    user-select: none;
                                }
                            }
                        }
                    }
                }
            }
            .container {
                height: 100%;
                max-width: 1170px;
                display: flex;
                align-items: center;
                padding: 0 35px;
            }
            .content {
                width: 100%;
                display: flex;
                justify-content: space-between;
                .left {
                    flex-basis: 34%;
                    padding: 13.4% 0 0;
                    .title {
                        margin-bottom: 4.2rem;
                        font: 800 to_rem(30px)/to_rem(36px) Geometria;
                        letter-spacing: to_rem(1px);
                        opacity: 0;
                        transition: .3s;
                    }
                    .strip {
                        width: 4.14rem;
                        height: to_rem(5px);
                        margin-bottom: 2.4rem;
                        margin-left: -2px;
                        background: #000;
                        opacity: 0;
                        transition: .3s;
                    }
                    .text {
                        margin-bottom: 4.4rem;
                        font: 400 to_rem(16px)/to_rem(24px) Geometria;
                        opacity: 0;
                        transition: .3s;
                    }
                }
                .right {
                    flex-basis: 46.9%;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    transition: 0.3s linear;
                    .absolute {
                        width: 100%;
                        padding-top: 53.9%;
                        margin-right: 4.2%;
                        margin-top: -1.2%;
                        background: url(../assets/img/about/weDoAbsolute.jpg) no-repeat center center / cover;
                        box-shadow: 0 to_rem(22px) to_rem(27px) rgba(0, 0, 0, 0.37);
                    }
                }
                .watchCase {
                    display: flex;
                    align-items: center;
                    transition: .3s;
                    .play {
                        width: 5.14rem;
                        height: 5.14rem;
                        margin-right: 1.43rem;
                        background: url(../assets/img/about/play.png) no-repeat center center / contain;
                        cursor: url(./../assets/img/cursor-hover.png) 25 25, pointer;
                    }
                    span {
                        font-size: to_rem(12px);
                    }
                }
            }
        }
    }
    @include razr1024L{
        section.aboutIntro{
            height: 230vh !important;
        }
        section.weDo{
            height: 230vh;
        }
    }
    @include razr768{
        .about {
            section.aboutIntro {
                background-image: url(../assets/img/about/aboutIntro_bg-mobile.jpg);
                .container {
                    .yellowP {
                        background: url(../assets/img/about/aboutIntro_bg-yellow-mobile.svg) no-repeat 50% 44%/auto 65.5vw;
                        z-index: -1;
                    }
                }
                .center {
                    .benefits {
                        position: absolute;
                        top: 13.2vh;
                        width: 90%;
                        font-size: 3vw;
                        left: 5%;
                    }
                    .title {
                        margin-left: 0;
                        margin-top: -5vh;
                        margin-bottom: 4.2vh;
                        line-height: 1.2;
                        font-size: 7vw;
                        letter-spacing: 2.76vw;
                        span{display: none;}
                    }
                    .subtitle {
                        font-size: 3.6vw;
                    }
                }
                .holding {
                    right: initial;
                    left: 9vw;
                    text-align: left;
                    font-size: 2.95vw;
                    line-height: 2;
                    bottom: 20.5vh;
                }
                .companiesLinks {
                    flex-wrap: wrap;
                    bottom: 9vh;
                    a {
                        height: 8vw;
                        width: 32vw;
                        margin: 0;
                        text-align: center;
                        img{
                            height: 100%;
                        }
                    }
                }
            }

            section.weDo {
                height: initial;
                &.doJoin {
                    overflow: hidden;
                    .content {
                        .left {
                            padding: 30vw 8.5vw 5vw;
                        }
                        .right {
                            height: 129vw;
                            div {
                                background: url(../assets/img/about/weDo-join-mobile.png) no-repeat 26% 15%/142% auto;
                            }
                        }
                    }
                }
                &.doProjects {
                    .decor {
                        top: 0;
                        left:0;
                        right: 0;
                        bottom: 0;
                        background: no-repeat center center / contain;
                        opacity: 0.4 !important;
                        &.d1 {
                            background-image: url(../assets/img/about/decor/doProjects_bg-1-mobile.png);
                            bottom: 47vw;
                        }
                        &.d2 {
                            background-image: url(../assets/img/about/decor/doProjects_bg-2-mobile.png);
                            bottom: 14vw;
                            left: 16vw;
                        }
                        &.d3 {background-image: url(../assets/img/about/decor/doProjects_bg-3-mobile.png);
                            left: 53vw;
                            top: 12vw;}
                        &.d4 {display: none;}
                    }
                }
                &.doResult {
                    .decor {
                        &.d1 {
                            top: 29.2%;
                            left: 0;
                            bottom: 13.5%;
                            background-image: url(../assets/img/about/decor/doResult_bg-1-mobile.png);
                        }
                        &.d2 {
                            top: 37%;
                            left: 0;
                            right: 0;
                            bottom: 21.2%;
                            background-image: url(../assets/img/about/decor/doResult_bg-2-mobile.png);
                        }
                        &.d3 {
                            top: 44.6%;
                            left: 8vw;
                            right: 7vw;
                            bottom: 28.8%;
                            background-image: url(../assets/img/about/decor/doResult_bg-3-mobile.png);
                        }
                        &.d4 {
                            top: 52%;
                            left: 31.5vw;
                            right: 31vw;
                            bottom: 36.3%;
                            background-image: url(../assets/img/about/decor/doResult_bg-4-mobile.png);
                        }
                    }
                    .content {
                        .left {
                            padding: 4vw 8.5vw 0;
                            .title {
                                margin-bottom: 13vw;
                            }
                        }
                        .right {
                            .absolute {
                                margin: 5vw 0 0;
                                width: 100%;
                            }
                            .statistic {
                                width: 100%;
                                flex-direction: column;
                                padding: 2vw 0 7vw 13vw;
                                .stat {
                                    width: 100%;
                                    margin-bottom: 10vw;
                                    line-height: 1;
                                    &:nth-of-type(1){order: 1;}
                                    &:nth-of-type(2){order: 3;}
                                    &:nth-of-type(3){order: 2;}
                                    &:nth-of-type(4){order: 4;}
                                    &:nth-of-type(2),&:nth-of-type(3){
                                        .big {
                                            margin-bottom: 0;
                                        }
                                        small {
                                            margin-bottom: 5vw;
                                        }
                                    }
                                    .big {
                                        margin-bottom: 5vw;
                                        font-size: 7vw;
                                    }
                                    small {
                                        display: inline-block;
                                        font-size: 5vw;
                                    }
                                }
                            }
                        }
                    }
                }
                &.doSplitExp {
                    padding-bottom: 8vw;
                    background-image: url(../assets/img/about/weDo-splitExp-bg-mobile.jpg);
                    .content {
                        .left {
                            padding: 12vw 8.5vw 17vw;

                            .title {
                                margin-bottom: 12vw;
                            }
                        }
                        .right {
                            height: 103vw;
                            .articlesLinks {
                                width: 88%;
                                max-width: 88%;
                                margin-left: 9.3%;
                                #mCSB_1_scrollbar_vertical .mCSB_dragger {
                                    height: 3.5vw !important;
                                    width: 3.5vw;
                                }
                                .mCSB_scrollTools {
                                    width: 3.5vw;
                                }
                                .link {
                                    font-size: 5vw;
                                    line-height: 1.7;
                                    &:not(:last-child) {
                                        border-bottom: 2px solid #d7e5c7;
                                    }
                                }
                            }
                        }
                    }
                }
                .container {
                    padding: 0;
                }
                .content {
                    flex-direction: column;
                    .left {
                        padding: 20vw 1.5vw 0 8.5vw;
                        .title {
                            margin-bottom: 13vw;
                            font-size: 8.05vw;
                            line-height: 1.2;
                        }
                        .strip {
                            margin-bottom: 11.5vw;
                            margin-left: -0.5vw;
                            width: 17.8vw;
                            height: 1.7vw;
                        }
                        .text {
                            font-size: 5.05vw;
                            line-height: 1.5;
                        }
                    }
                    .right {
                        flex-direction: column;
                        align-items: flex-start;
                        .absolute {
                            margin-right: 0;
                            padding-top: initial;
                            height: 56vw;
                            margin-top: 11vw;
                        }
                    }
                    .watchCase {
                        padding: 10vw 0 15.5vw 9vw;
                        .play {
                            width: 16.5vw;
                            height: 16.5vw;
                            margin-right: 6vw;
                        }
                        span {
                            font-size: 3.8vw;
                        }
                    }
                }
            }
        }
    }

</style>